// Consent-gated analytics loader. Nothing here runs until the visitor accepts
// cookies (CookieConsent.jsx calls loadAnalytics on accept + on return visits
// with a stored "accepted" choice). "Necessary only" -> never loads.
const GA_ID = "G-TFYENVJS46";
const POSTHOG_KEY = "phc_xAvL2Iq4tFmANRE7kzbKwaSqp1HJjN7x48s3vr0CMjs";

export function loadAnalytics() {
    if (window.__hcAnalyticsLoaded) return;
    window.__hcAnalyticsLoaded = true;

    // Google Analytics (gtag.js)
    const g = document.createElement("script");
    g.async = true;
    g.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(g);
    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }
    window.gtag = gtag;
    gtag("js", new Date());
    gtag("config", GA_ID);

    // PostHog
    const p = document.createElement("script");
    p.async = true;
    p.crossOrigin = "anonymous";
    p.src = "https://us-assets.i.posthog.com/static/array.js";
    p.onload = () => {
        if (window.posthog?.init) {
            window.posthog.init(POSTHOG_KEY, {
                api_host: "https://us.i.posthog.com",
                person_profiles: "identified_only",
                session_recording: {
                    recordCrossOriginIframes: true,
                    capturePerformance: false,
                },
            });
        }
    };
    document.head.appendChild(p);
}

export function hasAnalyticsConsent() {
    try {
        const raw = localStorage.getItem("hc_cookie_consent");
        return raw ? JSON.parse(raw).value === "accepted" : false;
    } catch {
        return false;
    }
}

// Fire a custom event to GA + PostHog when they're loaded (post-consent).
// No-ops silently pre-consent so callers never need to guard.
export function trackEvent(name, props = {}) {
    try {
        if (typeof window.gtag === "function") window.gtag("event", name, props);
        if (window.posthog?.capture) window.posthog.capture(name, props);
    } catch {
        /* analytics must never break the UI */
    }
}
